module.exports = __webpack_public_path__ + "static/media/profileplaceholder.7d53238a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profileplaceholder.jpg
// module id = 91
// module chunks = 0